import React from 'react';
import { useSelector } from 'react-redux';

import UserDateTimezoneFormat from '../../../components/user-date-timezone-format';
import { useSalesOrderForFulfillmentId } from '../../../hooks/entities/selectors/fulfillments';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const OrderDateColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  const salesOrder = useSalesOrderForFulfillmentId(fulfillmentId);
  const { orderDateTime } = salesOrder;

  if (ret) return <UserDateTimezoneFormat dateTime={ret?.createdDateTime} />;

  return orderDateTime ? <UserDateTimezoneFormat dateTime={orderDateTime} /> : '';
};

export const OrderDate = {
  getMessageDescriptor: () => messages.orderDate,
  id: 'orderDate',

  render: (data) => {
    if (!data) {
      return;
    }
    return <OrderDateColumn fulfillmentId={data.id} />;
  },
};
